import * as React from 'react'

import type Store from 'modules/attendance/components/ClockIn/Store'

import DailyShifts from './DailyShifts'
import HourlyShifts from './HourlyShifts'

interface Props {
  store: Store
  showHourBalance: boolean
  isDaily: boolean
}

const Shifts = ({ store, showHourBalance, isDaily }: Props) => {
  if (isDaily) {
    return <DailyShifts store={store} />
  }

  return <HourlyShifts store={store} showHourBalance={showHourBalance} />
}

export default Shifts
